var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.94995C6.48 2.94995 2 7.42995 2 12.95C2 18.47 6.48 22.95 12 22.95C17.52 22.95 22 18.47 22 12.95C22 7.42995 17.52 2.94995 12 2.94995ZM16.03 13.48L13.03 16.48C12.88 16.63 12.69 16.7 12.5 16.7C12.31 16.7 12.12 16.63 11.97 16.48C11.68 16.19 11.68 15.71 11.97 15.42L13.69 13.7H8.5C8.09 13.7 7.75 13.36 7.75 12.95C7.75 12.54 8.09 12.2 8.5 12.2H13.69L11.97 10.48C11.68 10.19 11.68 9.70995 11.97 9.41995C12.26 9.12995 12.74 9.12995 13.03 9.41995L16.03 12.42C16.32 12.71 16.32 13.19 16.03 13.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b89e949b866ab2d394c4303c280da504.svg";
export { ForwardRef as ReactComponent };